import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Case Battles',
    tabActive: 'Active',
    tabHistoryAll: 'Completed',
    tabHistoryMine: 'My Battles',
    createBattle: 'Create Battle',
    empty: 'No battles yet',
    emptyHint: 'Start your own — rivals will show up.',
    emptyHistory: 'No battle history',
    loading: 'Loading...',
    historyMineLoginReason: 'Sign in to see your battles.',
    refreshFailed: "Couldn't refresh — showing the last loaded battles",
    retry: 'Tap to retry',
  },
  ru: {
    title: 'Case Battles',
    tabActive: 'Активные',
    tabHistoryAll: 'Завершенные',
    tabHistoryMine: 'Мои баттлы',
    createBattle: 'Создать баттл',
    empty: 'Баттлов пока нет',
    emptyHint: 'Собери свой — соперники подтянутся.',
    emptyHistory: 'Нет истории баттлов',
    loading: 'Загрузка...',
    historyMineLoginReason: 'Войди, чтобы видеть свои баттлы.',
    refreshFailed: 'Не удалось обновить, показаны последние данные',
    retry: 'Нажми, чтобы повторить',
  },
  uz: {
    title: 'Keys Janglar',
    tabActive: 'Faol',
    tabHistoryAll: 'Tugallangan',
    tabHistoryMine: 'Mening janglarim',
    createBattle: "Jang yaratish",
    empty: 'Hozircha janglar yoʻq',
    emptyHint: 'Oʻz jangingni yarat — raqiblar keladi.',
    emptyHistory: 'Jang tarixi yoʻq',
    loading: 'Yuklanmoqda...',
    historyMineLoginReason: 'Oʻz janglaringizni koʻrish uchun kiring.',
    refreshFailed: 'Yangilab boʻlmadi — oxirgi yuklangan janglar koʻrsatilmoqda',
    retry: 'Qayta urinish uchun bos',
  },
  fa: {
    title: 'نبرد کیس',
    tabActive: 'فعال',
    tabHistoryAll: 'تمام‌شده',
    tabHistoryMine: 'نبردهای من',
    createBattle: 'ساخت نبرد',
    empty: 'هنوز نبردی نیست',
    emptyHint: 'نبرد خودت را بساز — حریف‌ها می‌آیند.',
    emptyHistory: 'تاریخچه نبردی نیست',
    loading: 'در حال بارگذاری...',
    historyMineLoginReason: 'وارد شو تا نبردهایت را ببینی.',
    refreshFailed: 'به‌روزرسانی نشد — آخرین نبردهای بارگذاری‌شده را نشان می‌دهیم',
    retry: 'برای تلاش دوباره بزن',
  },
  pt: {
    title: 'Batalhas de caixas',
    tabActive: 'Ativas',
    tabHistoryAll: 'Concluídas',
    tabHistoryMine: 'Minhas batalhas',
    createBattle: 'Criar batalha',
    empty: 'Ainda não há batalhas',
    emptyHint: 'Crie a sua — os rivais vão aparecer.',
    emptyHistory: 'Sem histórico de batalhas',
    loading: 'Carregando...',
    historyMineLoginReason: 'Entre para ver suas batalhas.',
    refreshFailed: 'Não foi possível atualizar — mostrando os últimos dados',
    retry: 'Toque para tentar de novo',
  },
  tr: {
    title: 'Kasa savaşları',
    tabActive: 'Aktif',
    tabHistoryAll: 'Biten',
    tabHistoryMine: 'Savaşlarım',
    createBattle: 'Savaş oluştur',
    empty: 'Henüz savaş yok',
    emptyHint: 'Kendi savaşını kur — rakipler gelir.',
    emptyHistory: 'Savaş geçmişi yok',
    loading: 'Yükleniyor...',
    historyMineLoginReason: 'Savaşlarını görmek için giriş yap.',
    refreshFailed: 'Yenilenemedi — son yüklenen veriler gösteriliyor',
    retry: 'Tekrar denemek için dokun',
  },
});
